import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router);

export default new Router({
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/informationen',
            name: 'informationen',

            component: () => import(/* webpackChunkName: "informationen" */ './views/InformationenPage'),
            meta: {
                title: "Wichtige Informationen"
            }
        },
        {
            path: '/feedback',
            name: 'feedback',

            component: () => import(/* webpackChunkName: "feedback" */ './views/FeedbackPage'),
            meta: {
                title: "Feedback"
            }
        },
        {
            path: '/impressum',
            name: 'impressum',

            component: () => import(/* webpackChunkName: "impressum" */ './views/ImpressumPage'),
            meta: {
                title: "Impressum"
            }
        },
        {
            path: '/datenschutz',
            name: 'datenschutz',

            component: () => import(/* webpackChunkName: "datenschutz" */ './views/DatenschutzPage'),
            meta: {
                title: "Datenschutz"
            }
        },
        {
            path: '/weinsuche',
            name: 'wine-search',

            component: () => import(/* webpackChunkName: "wine-search" */ './views/WineSearch'),
            meta: {
                title: "Interaktiver Aussteller-Katalog"
            }
        },
        {
            path: '/merkzettel',
            name: 'wine-list',

            component: () => import(/* webpackChunkName: "wine-list" */ './views/WineList'),
            meta: {
                title: "Merkzettel"
            }
        }
    ]
});
